import BaseCarouselSlick from '../abstracts/BaseCarouselSlick';

const debug = false;

export default class CarouselComponentSlick extends BaseCarouselSlick {
  
  constructor(element) {
    super(element);
    debug && console.log('CarouselComponentSlick', 'this.$el', this.$el);

    this.mount(this.$el, this.$options);
  }
  
}